<template>
  <div class="scenicParkDetail">
    <loading v-if="isLoading"></loading>
    <div v-else>
      <div v-if="!isPageError">
        <div class="banner_container">
          <div class="silence" @click="silenceStatus" v-if="showSilence && (bannerIndex < videoArr.length)">
            <img :src="silence?require('../../assets/img/silence_icon.png'):require('../../assets/img/noSilence_icon.png')" alt="">
          </div>
          <van-swipe ref="vantSwipe" width="100%" height="177px" :autoplay="autoplay" :loop="true" :show-indicators="true" @change="swiperChange('video',$event)">
            <div slot="indicator" class="indicator_box">
              {{bannerIndex + 1}} / {{videoArr.length+imgList.length}}
            </div>
            <van-swipe-item v-for="(item,index) in videoArr" :key="index" :style="{position:'relative'}" @click="swiperItem">
              <!-- x5-playsinline="" x-webkit-airplay="allow" playsinline="true" webkit-playsinline="true" -->
              <video :muted="silence" @canplay="listenerCanplay" @waiting="listenerWaiting" @play="listenerPlay" @pause="listenerPause" @ended="listenerEnd" playsinline="" webkit-playsinline="" x5-video-player-type="h5" x5-video-player-fullscreen="true" class="video_ele" :src="item.videoUrl" :poster="item.imageUrl" @click="clickVideo"></video>
              <img class="video_icon" v-show="isShowIcon && showPlayIcon" @click.stop="videoPlay('play')" src="../../assets/img/playVideo_icon.png" alt="">
              <img class="video_icon" v-show="isShowIcon && showPauseIcon" @click.stop="videoPlay('pause')" src="../../assets/img/pauseVideo_icon.png" alt="">
              <img v-show="isWaiting" class="video_waiting" src="../../assets/images/loading.gif" alt="">
            </van-swipe-item>

            <van-swipe-item v-for="(item) in imgList" :key="item" @click="swiperItem">
              <van-image width="100%" :height="234" :src="item"></van-image>
            </van-swipe-item>
          </van-swipe>
          <div class="checkout_box" v-if="imgList.length > 0 && videoArr.length > 0">
            <div class="checkout_item" :class="{checkout_box_active:checkoutType=='video'}" @click="checkoutItem('video')">视频</div>
            <div class="checkout_item" :class="{checkout_box_active:checkoutType=='img'}" @click="checkoutItem('img')">图片</div>
          </div>
        </div>
        <div class="desc_container">
          <div class="desc_title">{{detailData.name}}</div>
          <div class="desc_label_box">
            <div class="desc_label" v-for="(item,index) in detailData.tags" :key="index">{{item}}</div>
          </div>
          <!-- 园内讲解 -->
          <div class="explain_container">
            <div class="top_icon">
              <div class="topIcon_item" v-if="audioWoMan || audioMan" @click="palyAudio">
                <img src="../../assets/img/say_icon.png" alt="">
                <div class="text">讲解</div>
              </div>
              <div class="topIcon_item" v-else :style="{visibility:'hidden'}">
                <img src="../../assets/img/say_icon.png" alt="">
                <div class="text">讲解</div>
              </div>
            </div>
          </div>
          <!-- 园内讲解 end-->
        </div>
        <div class="intro_container">
          <div class="intro_title">{{detailData.name}}介绍</div>
          <div class="intro_innerText" v-html="detailData.brief"></div>
          <div class="intro_four_box">
            <div class="intro_four_item" :style="{marginLeft:0}">
              <!-- <img src="../../assets/img/user_img.png" alt=""> -->
              <div class="intro_top">
                <div class="top_left">{{detailData.ecologicalLand}}</div>
                <div class="top_right">
                  <div>平方</div>
                  <div>公里</div>
                </div>
              </div>
              <div class="intro_bottom">生态用地</div>
            </div>
            <div class="intro_four_item">
              <div class="intro_top">
                <div class="top_left">{{detailData.totalLength}}</div>
                <div class="top_right">
                  <div>公里</div>
                </div>
              </div>
              <div class="intro_bottom">绿道总长度</div>
              <!-- <img src="../../assets/img/allLine_img.png" alt=""> -->
            </div>
            <div class="intro_four_item">
              <div class="intro_top">
                <div class="top_left">{{detailData.townCount}}</div>
                <div class="top_right">个</div>
              </div>
              <div class="intro_bottom">特色小镇</div>
              <!-- <img src="../../assets/img/xiaozhen_img.png" alt=""> -->
            </div>
            <div class="intro_four_item">
              <div class="intro_top">
                <div class="top_left">{{detailData.gardenCount}}</div>
                <div class="top_right">个</div>
              </div>
              <div class="intro_bottom">特色园区</div>
              <!-- <img src="../../assets/img/yuanqu_img.png" alt=""> -->
            </div>
          </div>
          <div class="intro_image">
            <img :src="detailData.planImg" alt="">
          </div>
          <div class="intro_eight">
            <div class="intro_title">8大功能区</div>
            <div class="intro_eight_box">
              <div class="intro_eight_item" v-for="(item,index) in detailData.scenicFunction" :key="index">
                <img class="item_icon" :src="item.icon" alt="">
                <div>{{item.name}}</div>
              </div>
            </div>

          </div>
        </div>

        <!-- 绿道景区 start -->
        <div class="recommend_container">
          <div class="recommend_title">
            <div class="title_left">绿道公园</div>
          </div>
          <div class="best_container">
            <div class="best_item" v-for="(item,index) in detailData.scenicList" :key="index" @click="toParkDetail(item)">
              <div class="item_left" :style="{width:'100px'}">
                <van-image radius="3px" :width="100" :height="100" lazy-load :src="item.imageList[0]" />
              </div>
              <div class="item_right">
                <div class="title item_title">{{item.name}}</div>
                <div class="distance">
                  <span class="distance" v-if="isShowDistance">距你{{distance(item.latitude,item.longitude)}}&nbsp;&nbsp;</span>
                  <span class="location">{{item.scenicArea}}</span>
                </div>
                <div class="label_box" v-if="item.facilities">
                  <div class="label" v-for="(item,index) in item.facilities" :key="index">{{item}}</div>
                </div>
                <div class="fun_label" v-if="item.tags">
                  <div class="funLabel_item" v-for="(item,index) in item.tags" :key="index" v-show="index < 2">{{item}}</div>
                  <!-- <div class="funLabel_item">{{item.tags[0]}}</div> -->

                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 绿道景区 end -->

        <!-- 用户评论 -->
        <div class="comment-box">
          <van-cell title="精彩点评" is-link :value="'全部 '+CommentNum + ' 条点评'" @click="AllDiscussList()" />
          <div class="comment-list" v-if="CommentNum !== 0">
            <customListView :arraydata="commentList" @itemDianZan="itemDianZan" @itemClick="Details" @bigPictureLook="bigPictureLook" @itemReply="itemReply">
            </customListView>
          </div>
          <div class="list-no" v-if="CommentNum === 0">
            <p>来发表第一条评论吧~</p>
          </div>
          <div class="btn">
            <van-button color="#2EBA73" @click="Write()">
              写点评
            </van-button>
          </div>
        </div>

        <div>
          <writeComment ref="writeComment" @Fb="Fb(arguments)" id="modalId"></writeComment>
        </div>

        <div>
          <displayimage ref="displayimage"></displayimage>
        </div>
        <!-- 用户评论 end -->
      </div>
      <page-error v-else></page-error>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
// import { Empty } from 'vant';
import LeftImg from '@/components/LeftImgRightText';
import PageError from '../../components/PageError';
import Loading from '@/components/loading';
import { getDistance } from '../../common/common';
import TabCheckout from '@/components/TabCheckout';
import writeComment from "@/components/writeComment.vue";
import customListView from "@/components/customListViewComment.vue";
import displayimage from "@/components/displayImage.vue";
import axios from 'axios'

// Vue.use(Empty);
export default {
  name: "line_list",
  data() {
    return {
      checkoutType: 'video',
      isPageError: false,
      isLoading: true,
      // 视频数组
      videoArr: [],
      // 图片数组
      imgList: [],
      CommentNum: 0, // 评论条数
      commentList: [],
      isVideo: false,
      scenicId: '',
      imgIndex: 0,
      videoIndex: 0,
      detailData: {},
      showPlayIcon: true,
      showPauseIcon: false,
      isShowDistance: false,
      // 全局音频组件所在vue实例对象 (App.vue)
      App: this.$root.$children[0],
      audioMan: '',
      audioWoMan: '',
      audioTitle: '',
      // swiper/视频 控制
      autoplay: 0,
      bannerIndex: 0,
      isShowIcon: false,
      // 是否静音
      silence: true,
      showSilence: false,
      // 视频是否在播放
      isPlay: false,
      flag: true,
      isWaiting: false
    };
  },
  components: {
    // LeftImg,
    Loading,
    PageError,
    // TabCheckout,
    writeComment,
    customListView,
    displayimage
  },
  props: ['audioStatus'],
  watch: {
    audioStatus: function (value) {
      if (value) {
        if ($('.video_ele').get(this.videoIndex)) {
          $('.video_ele').get(this.videoIndex).pause();
          this.isShowIcon = true;
        }
      }
    },

    // silence: function (value) {
    //   console.log(value,'value')
    //   $('.video_ele').get(this.videoIndex).muted = value;
    //   // if (value) {
    //   //   ();
    //   // } else {
    //   //   $('.video_ele').get(this.videoIndex).pause();
    //   // }
    // }
  },
  mounted() {
    this.uid = this.$cookie.get('w_uid') || '';
    this.scenicId = this.$route.query.id;
    this.isShowDistance = Boolean(sessionStorage.getItem('isShowDistance'));
    console.log(this.$route.meta, 'routemetaroutemeta');


    // 绿道名片详情页评论数据依赖详情返回的id值
    this.getScenicDetail().then(() => {
      this.getCommentList();
    });

  },
  methods: {


    /**
     * 静音/不静音
     */
    silenceStatus() {
      this.silence = !this.silence;
    },


    /**
     * 监听视频缓冲中
     */
    listenerWaiting(e) {
      console.log('缓冲中');
      console.log(e);
      this.isWaiting = true;
    },

    /**
     *   视频缓冲结束
     */
    listenerCanplay() {
      console.log('缓冲结束');
      this.isWaiting = false;
    },


    /**
     * 监听视频播放
     */
    listenerPlay(e) {
      this.isWaiting = false;
      console.log('视频播放');
      this.autoplay = 0;
      if (this.audioStatus) {
        this.App.pauseAudio();
      }
      this.isPlay = true;
      if (this.$route.meta.currentTime) {
        // setTimeout(() => {
        console.log(e.target, 'e.targete======> timeout');
        // ios处理
        if (this.isIos) {
          e.target.addEventListener("canplay", () => {
            this.isWaiting = false;
            //设置播放时间
            if (this.flag) {
              e.target.currentTime = Number(this.$route.meta.currentTime);
              this.flag = false;
            }
          });
        } else {  // 安卓处理
          //设置播放时间
          e.target.addEventListener("timeupdate", () => {
            this.isWaiting = false;
            this.$nextTick(() => {
              if (this.flag) {
                e.target.currentTime = Number(this.$route.meta.currentTime) + 2;
                this.flag = false;
              }
            })

          });

        }
        // }, 300)
      }
    },

    /**
     * 监听视频停止
     */
    listenerEnd() {
      console.log('视频停止');
      this.isWaiting = false;
      this.showPlayIcon = true;
      this.isShowIcon = true;
      // 重置时间
      $('.video_ele').get(this.videoIndex).currentTime = 0;
      this.isPlay = false;
      this.$route.meta.currentTime = '';
      this.$route.meta.playStatus = '';
      this.$route.meta.muted = '';
      sessionStorage.removeItem('allVideoCurrentTime');
      sessionStorage.removeItem('playStatus');
      sessionStorage.removeItem('muted');
      this.autoplay = 3000;
    },

    /**
     * 监听视频暂停
     */
    listenerPause() {
      console.log('视频暂停');
      this.isWaiting = false;
      this.showPlayIcon = true;
      this.isShowIcon = true;
      this.isPlay = false;
      this.autoplay = 3000;
    },

    /**
         * swiper点击事件
         */
    swiperItem() {
      // if (this.showPlayIcon) {   // 代表视频未处于播放状态
      this.$router.push({
        name: 'newAllVideoPictures',
        query: {
          images: JSON.stringify(this.imgList),
          video: JSON.stringify(this.videoArr),
          bannerIndex: this.bannerIndex,
          currentTime: this.videoArr.length > 0 ? $('.video_ele').get(this.videoIndex).currentTime : '',
          muted: this.silence ? 1 : 0,
          isPlay: this.isPlay
        }
      })
      // }

    },

    /**
     * 循环添加video监听事件
     */
    loopListener() {
      this.$nextTick(() => {
        console.log($('.video_ele'), "$('.video_ele')")
        for (let i in this.videoArr) {
          this.Videostate($('.video_ele').get(i));
        }
      })
    },

    /**
     * 监听video播放状态
     */
    Videostate(ele) {
      ele.addEventListener('play', () => {//播放开始执行的函数
        this.autoplay = 0;
        console.log('播放开始')
        this.videoPlay('play');
      });
      ele.addEventListener('pause', () => {//暂停开始执行的函数
        this.autoplay = 3000;
        console.log('播放暂停')
        this.videoPlay();

      });
      ele.addEventListener('ended', () => {//暂停开始执行的函数
        this.autoplay = 3000;
        console.log('播放停止');
        // this.videoPlay();

      });
    },

    /**
     * 讲解click事件
     */
    palyAudio() {
      this.App.audioWoMan = this.audioWoMan == '[]' ? '' : this.audioWoMan;
      this.App.audioMan = this.audioMan == '[]' ? '' : this.audioMan;
      this.App.audioTitle = this.audioTitle;
      this.App.palyAudio();
      if ($('.video_ele').get(this.videoIndex)) {
        $('.video_ele').get(this.videoIndex).pause();
        this.isShowIcon = true;
      }

    },


    // 轮播图滚动事件
    swiperChange(type, event) {
      let videoElement = $('.video_ele').get(event - 1);
      if (videoElement) {
        videoElement.pause();
      }
      if (event > this.videoArr.length - 1) {
        this.isVideo = false;
        this.checkoutType = 'img';
      } else {
        this.isVideo = true;
        this.checkoutType = 'video';
      }
      this.bannerIndex = event;

    },

    /**
    *  切换视频/音频
    */
    checkoutItem(item) {
      this.imgIndex = 0;
      this.videoIndex = 0;
      this.checkoutType = item;
      this.isVideo = (item === 'video');
      if (item == 'video') {
        this.$refs['vantSwipe'].swipeTo(0)
      } else {
        this.$refs['vantSwipe'].swipeTo(this.videoArr.length)
      }

    },

    /**
     * 点击视频
     */
    clickVideo() {
      console.log('sdasdasd')
      console.log(this.showPlayIcon, 'sdasdasd')
      // 视频播放中执行
      if (!this.showPlayIcon) {
        this.showPauseIcon = true;
        setTimeout(() => {
          this.showPauseIcon = false;
        }, 1000)
      } else {  // 视频暂停中 跳转图集
        // console.log('')
        // return;
        // this.$router.push({
        //   name: 'newAllVideoPictures',
        //   query: {
        //     images: JSON.stringify(this.imgList),
        //     video: JSON.stringify(this.videoArr)
        //   }
        // })
      }
    },

    /**
     * 跳转至景区详情
     */
    toParkDetail(item) {
      this.$router.push({
        name: 'scenicParkDetail',
        query: {
          id: item.scenicId,
          lat: this.$route.query.lat,
          lng: this.$route.query.lng
        },
      });
    },

    /**
     * 控制视频播放/暂停
     */
    videoPlay(event) {
      // console.log(,'videoIndex')
      // console.log(,"$('.video_ele')")
      if (event == 'play') {
        $('.video_ele')[this.videoIndex].play();
        this.showPlayIcon = false;
        // this.showPauseIcon = true;
        setTimeout(() => {
          this.showPauseIcon = false;
        }, 1000)
      } else {
        $('.video_ele')[this.videoIndex].pause();
        // this.showPlayIcon = true;
        this.showPauseIcon = false;
      }
    },
    /**
     * 获取绿道名片数据
     */
    getScenicDetail() {
      return new Promise((resolve, reject) => {
        this.$request.get(`/appserver/v1/scenic/greenRoad/detail`).then((res) => {
          if (res.data.ret == 0) {
            let resData = res.data.data;
            console.log(resData);
            this.isLoading = false;
            if (resData.video && resData.video.length > 0) {   // 视频存在时
              this.isVideo = true;
              this.videoArr = resData.video;
              this.autoPlayVideo();  // 自动播放
            } else {
              this.isVideo = false;
            }
            if (resData.imageList) {
              this.imgList = resData.imageList;
            }
            // 音频组件赋值
            this.audioMan = resData.audio.voiceMan == '[]' ? '' : resData.audio.voiceMan;
            this.audioWoMan = resData.audio.voiceWoman == '[]' ? '' : resData.audio.voiceWoman;
            this.audioTitle = resData.name;
            let brief = resData.brief.replace(/\n/g, '<br>');
            brief = brief.replace(/\s/g, '&nbsp;');
            this.detailData = resData;
            this.detailData.brief = brief;
            setTimeout(() => {
              this.shareInit();
            }, 500)
          } else {
            this.isLoading = false;
            this.isPageError = true;
          }
          resolve();
        }).catch((e) => {
          console.log(e);
          this.isLoading = false;
          this.isPageError = true;
          reject(e);
        });
      })

    },

    /**
       * 跳转至导航页
       */
    toMap(lat, lng, location, address) {
      address = address ? address : ' ';
      this.openLocation(lat, lng, location, address);
    },

    /**
     * 自动播放视频
     */
    autoPlayVideo() {
      this.$nextTick(() => {

        if (this.$route.meta.currentTime) {
          if (this.$route.meta.playStatus) {
            if (window.WeixinJSBridge) {
              WeixinJSBridge.invoke('getNetworkType', {}, (e) => {
                this.videoPlay('play');
              })
            } else {
              document.addEventListener("WeixinJSBridgeReady", () => {
                WeixinJSBridge.invoke('getNetworkType', {}, (e) => {
                  this.videoPlay('play');
                })
              }, false);
            }
          } else {
            this.isShowIcon = true;
            this.autoplay = 3000;
          }
          this.silence = this.$route.meta.muted; // 静音
          wx.getNetworkType({
            success: (res) => {
              if (res.networkType == 'wifi') {
                this.showSilence = true; // 不显示
              } else {  // 4G
                this.showSilence = false; // 不显示
              }
            },
            fail: function (res) { }
          });
        } else {
          wx.ready(() => {
            wx.getNetworkType({
              success: (res) => {
                if (res.networkType == 'wifi') {
                  this.isShowIcon = false;
                  if (window.WeixinJSBridge) {
                    WeixinJSBridge.invoke('getNetworkType', {}, (e) => {
                      this.videoPlay('play');
                      this.silence = true; // 静音
                      this.showSilence = true; // 显示
                    })
                  } else {
                    document.addEventListener("WeixinJSBridgeReady", () => {
                      WeixinJSBridge.invoke('getNetworkType', {}, (e) => {
                        this.videoPlay('play');
                        this.silence = true; // 静音
                        this.showSilence = true; // 显示
                      })
                    }, false);
                  }
                } else {  // 4G
                  this.silence = false; // 不静音
                  this.showSilence = false; // 不显示
                  this.isShowIcon = true;
                }
              },
              fail: function (res) {
                console.log('当前无网络');
              }
            });
          })
        }

      })
    },

    /**
    * 计算距离你多少距离
    * @params lat lng 景区 景点 经纬度
    */
    distance(lat, lng) {
      if (this.$route.query.lat && this.$route.query.lng) {
        let obj = getDistance(lat, lng, this.$route.query.lat, this.$route.query.lng);
        return obj.distance.toFixed(1) + (obj.type == 'km' ? '公里' : '米');
      } else {
        // return { distance: '', text: '' };
        return '0米';
      }
    },
    /**
     * 获取评论
     */
    getCommentList() {
      let fromData = new FormData();
      console.log(this.detailData.id, 'this.grenen')
      fromData.append("cid", this.detailData.id);
      fromData.append("type", 'green_road_card');
      this.$request.post(`/appserver/v1/comment/list`, fromData)
        .then((data) => {
          let _data = data.data.data;
          if (_data.list.length !== 0) {
            this.commentList = _data.list;
          }
          this.CommentNum = _data.comment_num; // 评论条数
        });
    },

    /**
     * 用户点赞回调 
     */
    itemDianZan(item, commId) {
      if (!this.uid) {
        if (this.$cookie.get('w_uid') == 0) {  // 登录了未绑定手机号
          this.$router.push({
            name: 'bindingPhone',
            query: {
              for: 'other'
            }
          })
        } else {  // 未登录
          this.wxAuth();
        }
        return;
      }
      let data = {
        comment_id: commId,
        number: "1",
      };
      let fromData = new FormData();
      fromData.append('comment_id', commId);
      fromData.append('number', 1);
      this.$request
        .post(`/appserver/v1/comment/deleteOrUp`, fromData, {
          headers: {
            uid: this.uid,
          },
        })
        .then((data) => {
          if (data.data.ret === 0) {
            item.up++;
            item.is_up = !item.is_up;
          } else {
            this.$toast(data.data.msg);
          }
        });
    },

    /**
     * 回复
     * @params item 回复的评论item commId  回复的commitId
     */
    itemReply(item, commId) {
      this.parentId = commId;
      var u = navigator.userAgent;
      var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      this.isIos = isIOS;
      if (isIOS) {
        let windheight = document.documentElement.clientHeight; //为唤起软键盘时当前窗口高度
        document.getElementById("modalId").style.position = "relative";
        window.onresize = function () {
          var docheight = document.documentElement.clientHeight; //唤起软键盘时窗口高度
          document.getElementById("write").style.bottom =
            docheight - windheight + "px";
        };
      }
      if (this.uid) {
        this.$refs.writeComment.showWriteDialog();
      } else {
        if (this.$cookie.get('w_uid') == 0) {  // 登录了未绑定手机号
          this.$router.push({
            name: 'bindingPhone',
            query: {
              for: 'other'
            }
          })
        } else {  // 未登录
          this.wxAuth();
        }
      }
    },

    // 用户评论列表
    AllDiscussList() {
      if (this.CommentNum <= 0) {
        return;
      } else {
        this.$router.push({
          path: "/allDiscussList",
          query: {
            cid: this.detailData.id,
            type: "green_road_card",
          },
        });
      }
    },
    // 评论详情
    Details(item) {
      this.$router.push({
        path: "/discussDetails",
        query: {
          comment_id: item.comment_id,
          type: "green_road_card",
          from: "web",
        },
      });
    },
    // 图片点击放大
    bigPictureLook(item, index) {
      let imageArr = [];
      for (let i = 0; i < item.length; i++) {
        if (item[i].checkRet == 1) { // 非法图片
          // imageArr.push('');
        } else {
          imageArr.push(item[i].data);
        }
      }
      this.$refs.displayimage.showBigPictureLook(imageArr, index);
    },
    // 写评论
    Write() {
      // 确保parentId为空，不是回复操作
      this.parentId = null;
      var u = navigator.userAgent;
      var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      if (isIOS) {
        let windheight = document.documentElement.clientHeight; //为唤起软键盘时当前窗口高度
        document.getElementById("modalId").style.position = "relative";
        window.onresize = function () {
          var docheight = document.documentElement.clientHeight; //唤起软键盘时窗口高度
          document.getElementById("write").style.bottom =
            docheight - windheight + "px";
        };
      }
      if (this.uid) {
        this.$refs.writeComment.showWriteDialog();
      } else {
        if (this.$cookie.get('w_uid') == 0) {  // 登录了未绑定手机号
          this.$router.push({
            name: 'bindingPhone',
            query: {
              for: 'other'
            }
          })
        } else {  // 未登录
          this.wxAuth();
        }
      }
    },
    // 发表
    Fb(msg) {
      var message = msg[0];
      var gallerysStr = msg[1];
      let fromData = new FormData();
      fromData.append('content', message);
      fromData.append('cid', this.detailData.id);
      fromData.append('ctitle', document.title);
      fromData.append('type', 'green_road_card');
      fromData.append('source_type', 'h5');
      fromData.append('image', gallerysStr);
      if (this.parentId) {
        fromData.append('parent_id', this.parentId);
      }
      this.$request
        .post(`/appserver/v1/comment/addComment`, (fromData), {
          headers: {
            uid: this.uid,
          },
        })
        .then((data) => {
          console.log(data, 'asdasdasdasd');
          if (data.data.ret == 0) {
            if (this.parentId) {
              this.$toast("回复成功");
            } else {
              this.$toast("发布成功");
            }
            this.getCommentList();
            this.$refs.writeComment.ClosePost();
          } else {
            this.$refs.writeComment.ClosePost();
            if (data.data.msg == 'uid不能为空') {
              this.wxAuth();
            } else {
              this.$toast(data.data.msg);
            }
          }
        });
    },

    /**
     * 初始化分享事件
     */
    shareInit() {
      console.log('初始化')
      wx.ready(() => {
        // eslint-disable-next-line
        //需在用户可能点击分享按钮前就先调用
        wx.updateAppMessageShareData({
          title: '天府绿道', // 分享标题
          desc: this.detailData.shareInfo.content, // 分享描述
          link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: this.detailData.shareInfo.pic, // 分享图标
          success: function () {
            // 分享成功
          },
        });
        wx.updateTimelineShareData({
          title: '天府绿道', // 分享标题
          link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: this.detailData.shareInfo.pic,
          success: function () {
            // 分享成功
          },
        });
      });
      wx.error(function (res) {
        // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
        alert('error: ' + res);
      });
    },
  },
  computed: {},
};
</script>
<style lang="scss" scoped>
.scenicParkDetail {
  .banner_container {
    position: relative;
    width: 100%;
    min-height: 177px;
    // background: gray;
    .silence {
      position: absolute;
      right: 20px;
      bottom: 40px;
      width: 34px;
      height: 18px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 10px;
      background: rgba(0, 0, 0, 0.5);
      z-index: 10;
      img {
        width: 18px;
        height: 18px;
      }
    }
    .video_icon {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 60px;
      height: 60px;
    }
    .video_waiting {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 40px;
      height: 40px;
    }
    .video_ele {
      width: 100%;
      height: 234px;
      object-fit: fill;
    }
    .indicator_box {
      position: absolute;
      bottom: 20px;
      right: 20px;
      color: white;
      padding: 2px 8px;
      background: rgba(0, 0, 0, 0.5);
      border-radius: 10px;
    }
    .checkout_box {
      position: absolute;
      bottom: 20px;
      left: 50%;
      transform: translateX(-50%);
      width: 80px;
      height: 20px;
      background: rgba(255, 255, 255, 0.75);
      display: flex;
      //   justify-content: space-around;
      align-items: center;
      border-radius: 10px;
      font-size: 12px;
      .checkout_item {
        width: 50%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .checkout_box_active {
        background: #2eba73;
        color: white;
        border-radius: 10px;
      }
    }
  }

  .desc_container {
    padding: 30px 20px;
    padding-bottom: 0;
    border-bottom: 5px solid rgba(0, 0, 0, 0.05);
    .desc_title {
      font-size: 24px;
      color: #262626;
      font-weight: 700;
    }
    .desc_label_box {
      margin-top: 10px;
      padding-bottom: 30px;
      border-bottom: 1px solid rgba(216, 216, 216, 0.3);
      .desc_label {
        padding: 0px 4px;
        background: rgba(97, 69, 247, 0.15);
        color: #6145f7;
        display: inline-block;
        margin-right: 5px;
        border-radius: 2px;
        font-size: 11px;
      }
    }
    .explain_container {
      .top_icon {
        width: 100%;
        height: 100px;
        display: flex;
        justify-content: space-around;
        align-items: center;
        .topIcon_item {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          img {
            width: 28px;
            height: 28px;
          }
          .text {
            font-size: 12px;
            color: #000;
            margin-top: 6px;
          }
        }
      }
    }
  }
  .intro_container {
    padding: 30px 20px;
    color: #262626;
    border-bottom: 5px solid rgba(0, 0, 0, 0.05);
    box-sizing: border-box;
    overflow-x: hidden;
    .intro_title {
      font-size: 20px;
      font-weight: 400;
    }
    .intro_innerText {
      font-size: 14px;
      color: #787878;
      margin-top: 10px;
      line-height: 20px;
    }
    .intro_four_box {
      display: flex;
      margin-top: 30px;
      justify-content: space-around;
      .intro_four_item {
        margin-left: 27px;
        .intro_top {
          display: flex;
          align-items: flex-start;
          .top_left {
            font-size: 23px;
            font-weight: bold;
            color: #2eba73;
            font-family: PingFangSC-Semibold, PingFangSC;
            letter-spacing: -1px;
          }
          .top_right {
            color: #bfbfbf;
            transform: translateY(5px);
            font-size: 8px;
            margin-left: 3px;
            div {
              white-space: nowrap;
            }
          }
        }
        .intro_bottom {
          font-family: PingFangSC-Medium, PingFang SC;
          text-align: center;
          font-size: 12px;
          color: #262626;
          font-weight: bold;
          margin-top: 4px;
        }
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
    .intro_image {
      width: 100%;
      height: auto;
      // padding: 20px;
      border: 1px dashed #ccc;
      box-sizing: border-box;
      margin-top: 30px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .intro_eight {
      margin-top: 30px;
      .intro_title {
        margin-bottom: 20px;
        font-weight: 400;
      }
      .intro_eight_box {
        // padding: 20px;
        box-sizing: border-box;
        display: flex;
        flex-wrap: wrap;
        background: rgba(46, 186, 115, 0.08);
        .intro_eight_item {
          width: 25%;
          padding: 20px 0px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          font-size: 12px;
          color: #000;
          div {
            margin-top: 4px;
          }
          img {
            width: 24px;
            height: 24px;
          }
        }
      }
    }
  }
  .recommend_container {
    margin-top: 30px;
    padding-left: 20px;
    .right_like {
      color: rgba(0, 0, 0, 0.5);
      font-size: 11px;
    }
    .label_component {
      font-size: 11px;
      color: #787878;
      margin-top: 4px;
    }
    .mustPlay_title,
    .recommend_title,
    .delicacy_title,
    .strategy_title,
    .waterfall_title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-right: 20px;
      margin-bottom: 20px;
      .title_left {
        font-size: 20px;
        font-weight: 400;
      }
      .title_right {
        display: flex;
        align-items: center;
        span {
          margin-right: 10px;
          font-size: 14px;
          color: rgba(0, 0, 0, 0.5);
        }
      }
      .title_tag {
        display: flex;
        align-items: center;
        white-space: nowrap;
        width: 100%;
        overflow-x: auto;
        ::-webkit-scrollbar {
          width: 0px;
        }
        .tag_item {
          margin-right: 30px;
          font-size: 16px;
          color: #787878;
          padding-bottom: 5px;
          cursor: pointer;
          width: initial;
        }
        .tag_item_active {
          font-size: 20px;
          color: #000000;
          position: relative;
          .item_line {
            position: absolute;
            bottom: 0;
            left: 50%;
            transform: translateX(-50%);
            width: 20px;
            height: 4px;
            background: #2ed07e;
            border-radius: 2px;
          }
        }
      }
    }
    .strategy_title {
      padding-right: 0;
    }
    .list_container {
      .title {
        font-size: 14px;
        font-weight: 700;
        color: #262626;
        margin-top: 0px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
      .date,
      .address {
        font-size: 11px;
        color: rgba(0, 0, 0, 0.25);
        margin-top: 4px;
      }
      .tags_container {
        display: flex;
        .tags {
          margin-right: 3px;
          margin-top: 4px;
          padding: 2px 4px;
          background: rgba(97, 69, 247, 0.15);
          color: #6145f7;
          font-size: 11px;
        }
      }
    }
  }
  .recommend_container {
    margin-top: 30px;
    padding-left: 20px;
    padding-right: 20px;
    margin-bottom: 30px;
    .best_container {
      .best_item {
        display: flex;
        margin-bottom: 25px;
        .item_right {
          margin-left: 18px;
          .title {
            font-size: 17px;
            color: #262626;
            font-weight: 700;
            margin-bottom: 8px;
          }
          .item_title {
            margin-bottom: 4px;
          }
          .distance {
            font-size: 12px;
            color: #787878;
            // letter-spacing: 0.5px;
            // display: flex;
            // align-items: center;
            .location {
              margin-left: 4px;
            }
          }
          .label_box {
            // display: flex;
            margin-bottom: 6px;
            height: 25px;
            line-height: 20px;
            overflow: hidden;
            .label {
              padding: 2px 5px;
              background: rgba(0, 0, 0, 0.05);
              border-radius: 2px;
              color: #787878;
              margin-right: 4px;
              font-size: 11px;
              display: inline-block;
            }
          }
          .fun_label {
            .funLabel_item {
              padding: 2px 5px;
              border: 1px solid #e6c693;
              color: #e6c693;
              font-size: 12px;
              display: inline-block;
              margin-right: 4px;
            }
          }
        }
      }
    }
    .right_like {
      color: rgba(0, 0, 0, 0.5);
      font-size: 11px;
    }
    .tags_container {
      display: flex;
      flex-wrap: wrap;
      max-height: 20px;
      overflow: hidden;
      margin-bottom: 4px;
      .tags {
        margin-right: 3px;
        padding: 1px 3px;
        background: rgba(0, 0, 0, 0.05);
        color: #787878;
        font-size: 11px;
      }
    }
    .label_component {
      font-size: 11px;
      color: #2eba73;
      margin-top: 4px;
    }
    .strategy_title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-right: 20px;
      margin-bottom: 20px;
      .title_left {
        font-size: 20px;
        font-weight: 400;
      }
      .title_right {
        display: flex;
        align-items: center;
        span {
          margin-right: 10px;
          font-size: 14px;
          color: rgba(0, 0, 0, 0.5);
        }
      }
      .title_tag {
        display: flex;
        align-items: center;
        white-space: nowrap;
        width: 100%;
        overflow-x: auto;
        ::-webkit-scrollbar {
          width: 0px;
        }
        .tag_item {
          margin-right: 30px;
          font-size: 16px;
          color: #787878;
          padding-bottom: 5px;
          cursor: pointer;
          width: initial;
        }
        .tag_item_active {
          font-size: 20px;
          color: #000000;
          position: relative;
          .item_line {
            position: absolute;
            bottom: 0;
            left: 50%;
            transform: translateX(-50%);
            width: 20px;
            height: 4px;
            background: #2ed07e;
            border-radius: 2px;
          }
        }
      }
    }
    .strategy_title {
      padding-right: 0;
    }
    .label {
      font-size: 11px;
      color: rgba(0, 0, 0, 0.25);
      margin-top: 4px;
      display: flex;
      .label_item {
        background: rgba(97, 69, 247, 0.15);
        color: #6e5adb;
        margin-right: 4px;
        padding: 3px 4px;
      }
    }
    .address {
      font-size: 11px;
      color: rgba(0, 0, 0, 0.25);
      margin-top: 4px;
    }
  }

  // 评论列表 start
  .comment-box {
    padding: 20px;
    padding-top: 30px;
    border-top: 5px solid rgba(0, 0, 0, 0.05);
    border-bottom: 5px solid rgba(0, 0, 0, 0.05);
    /deep/ .van-cell {
      margin: 25px 0px;
      padding: 0px;
    }
    /deep/ .van-cell__title span {
      font-size: 20px;
      font-family: PingFangTC-Medium, PingFangTC;
      font-weight: 400;
      color: rgba(55, 56, 77, 1);
    }
    /deep/ .van-cell__value {
      font-size: 15px;
      font-family: PingFangSC-Light, PingFang SC;
      // font-weight: 300;
      color: #000;
    }
    /deep/ .van-cell:not(:last-child)::after {
      border: 0px;
    }
    /deep/ .van-icon {
      color: #37384d;
      font-size: 16px;
    }
    .comment-list {
      padding: 0px;
    }
    .list-no {
      text-align: left;
      // padding: 30px 0px 0px 0px;
      & > p {
        height: 14px;
        font-size: 15px;
        font-family: PingFangSC-Light, PingFang SC;
        font-weight: 300;
        color: rgba(153, 153, 153, 1);
        line-height: 14px;
      }
    }
    .btn {
      margin-top: 29px;
      width: 100%;
      opacity: 0.95;
      margin-bottom: 24px;
      /deep/ .van-image {
        margin-right: 4px;
        margin-top: -3px;
        img {
          border-radius: 3px;
        }
      }
      /deep/ .van-button {
        width: 100%;
        border: 0px;
        height: 40px;
      }
      /deep/ .van-button span {
        display: flex;
        justify-content: center;
        align-items: center;
        color: #fff;
        /deep/ .van-icon {
          color: #fff;
          margin-right: 7px;
        }
      }
      /deep/ .van-icon {
        color: #fff;
        margin-right: 7px;
      }
    }
  }
  // 评论列表 end
  // 隐藏video控件
  video::-webkit-media-controls-enclosure {
    display: none !important;
  }
  video {
    object-fit: fill;
  }
}
</style>
